import styled from 'styled-components';
import { FlexRowCentred } from '../common-styles/common-styles';

export const ScoreEntryWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 0.25rem;
`;

export const FlexColumn = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: 0 0.25rem;
  align-items: center;
  width: 100%;
`;

export const FlexRow = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  margin-bottom: 0.25rem;
`;

export const DivWithMargin = styled.div<{ borderColour?: string | null }>`
  border: 4px solid ${(props) => props.borderColour || 'black'};
  border-radius: 5px;
  margin: 0.5rem 0;
  padding: 0;
`;

export const MiddleSection = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid black;
  border-radius: 0.25rem;
  padding: 0.5rem 1rem;
  width: 20rem;
`;

export const Title = styled.div`
  font-size: 1.25rem;
  text-align: center;
  padding: 0 0.5rem;
  font-weight: bold;
`;

export const HoleInfoTitle = styled.div`
  font-size: 1.5rem;
  text-align: center;
  padding: 0 0.5rem;
  font-weight: bold;
`;

export const ConfirmationData = styled.div`
  font-size: 1.5rem;
  text-align: center;
  width: 6rem;
  margin: 0.5rem 0;
`;

export const HoleNumber = styled.div`
  font-size: 3rem;
  text-align: center;
  min-width: 3.25rem;
`;

export const HoleInfo = styled.div`
  width: 2.25rem;
  height: 2.25rem;
  padding: 0.25rem;
  text-align: center;
  border: solid 1px black;
  font-size: 1.5rem;
  font-weight: 400;
  margin-top: 0.25rem;
`;
export const SI = styled.span`
  color: red;
`;
export const CrementButton = styled.button`
  width: 1.5rem;
  height: 2.25rem;
  padding: 0.25rem;
  text-align: center;
  border: solid 1px black;
  font-size: 1.5rem;
  margin-top: 0.25rem;
  background-color: aliceblue;
`;

export const HoleNavigationButton = styled.button`
  width: 8rem;
  font-size: 1rem;
  color: black;
  height: 2.25rem;
  margin: 0.25rem 0.5rem;
  background-color: aliceblue;
  border-radius: 0.25rem;
`;
export const NavigationButton = styled.button`
  width: 5rem;
  font-size: 0.75rem;
  color: black;
  height: 2.5rem;
  margin: 0.25rem 1.25rem;
  background-color: aliceblue;
  border-radius: 0.25rem;
  height: 2rem;
`;

export const ConfirmationHeader = styled.div`
  background: white;
  color: black;
  font-size: 2rem;
  height: 4rem;
  padding: 0.75rem;
  text-align: center;
  border-radius: 5px;
`;

export const NavigationWrapper = styled.div`
  margin: 1.5rem 0;
`;

export const Asterisk = styled.div`
  font-size: 2rem;
  min-width: 2rem;
  height: 1.5rem;
`;

export const VerticalText = styled.div<{ bgColour?: string | null }>`
  background: ${(props) => props.bgColour || 'white'};
  color: white;
  text-orientation: upright;
  writing-mode: vertical-lr;
  margin: 0;
  text-align: center;
  padding: 0.5rem 0.25rem;
  min-height: 8rem;
`;

export const MatchOverAllResult = styled.div<{ colour?: string | null }>`
  color: ${(props) => props.colour || 'black'};
  font-size: 1.5rem;
  font-weight: bold;
  padding: 0 0.5rem;
`;

export const Arrow = styled.i`
  display: inline-block;
  width: 10px;
  height: 10px;
  vertical-align: middle;
  margin: 0 0.25rem;
`;

export const ArrowUp = styled(Arrow)`
  border: solid red;
  border-width: 0 4px 4px 0;
  padding: 4px;
  transform: rotate(-135deg);
`;

export const ArrowDown = styled(Arrow)`
  border: solid blue;
  border-width: 0 4px 4px 0;
  padding: 4px;
  transform: rotate(45deg);
`;

export const ArrowLeft = styled(Arrow)`
  border: solid gray;
  border-width: 0 4px 4px 0;
  padding: 4px;
  transform: rotate(135deg);
`;

export const ArrowRight = styled(Arrow)`
  border: solid gray;
  border-width: 0 4px 4px 0;
  padding: 4px;
  transform: rotate(-45deg);
`;

export const PlayerNameTitle = styled.div`
  min-width: 5.25rem;
  font-size: 1.2rem;
  font-weight: bold;
  padding-left: 0.5rem;
`;

export const PlayerNameTitleX = styled(PlayerNameTitle)`
  padding-left: 1.75rem;
`;

export const PlayerShotsTitle = styled.div`
  min-width: 5rem;
  font-size: 1.2rem;
  font-weight: bold;
  text-align: center;
  padding-left: 0.5rem;
`;

export const HandicapTitle = styled.div`
  min-width: 5rem;
  font-size: 1.2rem;
  font-weight: bold;
  margin-right: 0.25rem;
  padding-left: 0.25rem;
`;

export const CrementWrapper = styled.div`
  margin-left: 0.25rem;
  margin-right: 0.25rem;
`;

export const PlayerName = styled.div`
  min-width: 6rem;
`;

export const PlayerShots = styled.div`
  min-width: 5.75rem;
  text-align: center;
`;

export const MatchWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0.5rem 0;
  border: 1px solid gray;
  padding: 0.5rem;
  border-radius: 5px;
`;

export const MatchResultDisplay = styled(FlexRowCentred)`
  margin: 1rem 0;
`;
export const CreatedMatch = styled.div<{ bgColour?: string | null }>`
  margin: 1rem;
  background: ${(props) => props.bgColour || 'black'};
  border-radius: 5px;
  padding: 1rem;
  min-width: 8rem;
  color: white;
`;

export const MatchEntryInput = styled.input`
  margin: 0 0.5rem;
`;
export const MatchEntryLabel = styled.label`
  margin-right: 0.5rem;
`;

export const TierPointsHoleTotal = styled.div`
  margin: 0.5rem 0;
  border-top: 2px dashed gray;
  border-bottom: 2px dashed gray;
  padding: 0.5rem;
  width: 100%;
  font-size: 1.5rem;
  font-weight: bold;
  text-align: center;
`;
